import {
    getData,
} from './Services'

export const getRamos = async () => {
    const res = await getData('/ramos/ramos_select');
    return res
}
